import { useMemo } from 'react'
import useMediaSelectionActions from '@/actions/useMediaSelectionActions'
import { useUserContext } from '@/UserContext'
import { queryCurrentMediaSelectionWithFallback } from '@/Logic'
import { SimpleSelect } from '@/UIComponents2/Select/SimpleSelect'
import SpeakerIcon from '@/CustomIcons/SpeakerIcon'
import { ControlButton } from '@/UIComponents2/ControlButton'
import GearIcon from '@/CustomIcons/GearIcon'
import { cn } from '@/utlis/cn'
import { SpeakerTest } from './SpeakerTest'

type SpeakerSelectProps = {
    onOpenSettings?: () => void
    playingTest?: boolean
    onTestEnded?: () => void
    className?: string
}
export function SpeakerSelect(props: SpeakerSelectProps) {
    const [userState] = useUserContext()
    const { setMediaSelection } = useMediaSelectionActions()

    const speakerOptions = useMemo(() => {
        const opts = userState.mediaSources.audioOutputs.map((source) => ({
            value: source.deviceId,
            label: source.label,
        }))
        opts.unshift({ value: '_none', label: 'None' })
        return opts
    }, [userState.mediaSources.audioOutputs])

    const selectedSpeaker = useMemo(
        () => queryCurrentMediaSelectionWithFallback(userState.mediaSelection, userState.mediaSources, 'audioOutput'),
        [userState.mediaSelection, userState.mediaSources]
    )

    const handleSpeakerChange = (deviceId: string | undefined) => {
        if (deviceId) {
            setMediaSelection({ audioOutput: deviceId })
        } else {
            setMediaSelection({ audioOutput: '_none' })
        }
    }

    return (
        <div className={cn('flex gap-2 w-full', props.className)}>
            <SimpleSelect
                items={speakerOptions}
                className="w-full"
                leftElement={<SpeakerIcon style={{ fontSize: '1.3rem' }} />}
                value={selectedSpeaker}
                onChange={handleSpeakerChange}
                widthMatching
            />
            {props.onOpenSettings && (
                <ControlButton variant="glow" onClick={() => props.onOpenSettings?.()}>
                    <GearIcon />
                </ControlButton>
            )}
            <SpeakerTest playing={props.playingTest ?? false} onEnded={() => props.onTestEnded?.()} />
        </div>
    )
}
